import React, {useEffect, useState} from 'react';
import axios from "axios";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import {
	Backdrop,
	Card,
	CardContent,
	CardHeader,
	CircularProgress,
	Divider,
	TextField,
	Typography
} from "@mui/material";
import clsx from "clsx";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {blue, green, orange, purple} from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import {KeyboardDatePickerCompat} from "../../../../widgets/inputs/KeyboardDatePickerCompat";

const TabellaRiassuntiva = () => {
	const classes = BaseStyle();
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(null);
	const [giorno, setGiorno] = useState(new Date())
	const [filterBy, setFilterBy] = useState("");
	
	useEffect(
		() => {
			if (giorno) {
				setLoading(true);
				axios
					.get("/atlantis-api-v1/API/automations/getAdvancedStatsByDay/" + moment(giorno).format("DD-MM-YYYY"), getConfig())
					.then((response) => {
						setData(response.data);
						setLoading(false);
					})
					.catch((error) => {
						setLoading(false);
						console.error(error)
					})
			} else {
				alert("Il giorno inserito non è valido!");
			}
		}, [giorno])
	
	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Tabella riassuntiva</b></Typography>}
					subheader={"Conteggio azioni per singolo utente"}
				/>
				<CardContent style={{flexGrow: 1}}>
					<Grid container spacing={2}>
						<Grid item xs={6}>
							<KeyboardDatePickerCompat
									margin="normal"
									id="date-picker-dialog"
									label="Data"
									inputVariant="outlined"
									format="dd/MM/yyyy"
									value={giorno}
									onChange={setGiorno}
									style={{
										width: "100%",
										marginTop: 0
									}}
									KeyboardButtonProps={{
										'aria-label': 'change date',
									}}
								/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								variant={"outlined"}
								value={filterBy}
								onChange={e => setFilterBy(e.target.value)}
								label={"Filtra per nome"}
								fullWidth={true}
							/>
						</Grid>
					</Grid>
					<div style={{overflow: "scroll", height: "60vh"}}>
						{
							data
								?.filter(elem => elem.operatore?.toUpperCase().includes(filterBy.toUpperCase()))
								.map((item, index) => {
									return (
										<div key={index}>
											<b>{item.operatore}</b><br/>
											<p>Provvedimenti: <b style={{fontSize: 18, color: purple[500]}}>{item.decorsi}</b> -
												Interviste: <b style={{fontSize: 18, color: green[500]}}>{item.interviste}</b> -
												Prenotazioni tamponi: <b
													style={{fontSize: 18, color: blue[500]}}>{item.prenotazioniTamponi}</b> -
												Ticket: <b style={{fontSize: 18, color: orange[500]}}>{item.ticket}</b></p>
											<Divider variant={"fullWidth"}/>
											<br/>
										</div>
									)
								})
						}
					</div>
				</CardContent>
			</Card>
		</React.Fragment>
	);
}

export default React.memo(TabellaRiassuntiva)
